// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2QROC","colCheckbox":"styles_colCheckbox__RWVfG"};